import { render, staticRenderFns } from "./ComercialTeletrabajo.vue?vue&type=template&id=4d822692&"
import script from "./ComercialTeletrabajo.vue?vue&type=script&lang=js&"
export * from "./ComercialTeletrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VWindow,VWindowItem})
